import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import service from '../service';
import type { PaginatedResponse } from '../types/api';
import type { RegistrationCodeSubscription } from '../types/registrationCode';
import { inviteCodeQueryKeys } from './useInviteCodes';

type InviteCodeSubscriptionsResponse = PaginatedResponse<
  RegistrationCodeSubscription[]
>;

type UseInviteCodeSubscriptionsParams = {
  id: string;
  searchParams?: Record<string, unknown>;
  enabled?: boolean;
};

export function useInviteCodeSubscriptions({
  id,
  searchParams = {},
  enabled = true,
}: UseInviteCodeSubscriptionsParams): UseQueryResult<
  InviteCodeSubscriptionsResponse,
  Error
> {
  return useQuery<InviteCodeSubscriptionsResponse, Error>({
    queryKey: inviteCodeQueryKeys.subscriptions(id, searchParams),
    enabled: enabled && !!id,
    queryFn: async () => service.getInviteCodeSubscriptions(id, searchParams),
  });
}
